import { render } from "./Xcxcate.vue?vue&type=template&id=7dbf89ac&scoped=true"
import script from "./Xcxcate.vue?vue&type=script&lang=js"
export * from "./Xcxcate.vue?vue&type=script&lang=js"

import "./Xcxcate.vue?vue&type=style&index=0&id=7dbf89ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbf89ac"]])

export default __exports__